import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-dvh flex flex-col bg-tile text-neutral2-600 absolute top-0 z-[1]" }
const _hoisted_2 = { class: "pt-3 px-4 pb-7 flex flex-col grow border-t border-tile-border overflow-y-scroll" }

import {computed} from "vue";
import {NavigationAction} from "../../Port/NavigationService";
import {useNavigationStore} from "../navigationStore";
import {authControlItems} from "../Presenter/authControlItems";
import {entryPointItems} from "../Presenter/entryPointItems";
import {useNavigationService} from "../vue";
import MobileMenuListItem from "./ListItem/MobileMenuListItem.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileDrawer',
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const service = useNavigationService();
const store = useNavigationStore();
const emit = __emit;

function action(action: NavigationAction): void {
  service.action(action);
  if (action !== 'toggleTheme') {
    close();
  }
}

const _authControlItems = computed(() => authControlItems(
  store.$state.navigationUser,
  store.$state.darkTheme,
));

function close(): void {
  emit('close');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "h-17.5 flex-shrink-0" }, null, -1 /* CACHED */)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(entryPointItems), (item) => {
        return (_openBlock(), _createBlock(MobileMenuListItem, {
          type: item.type,
          title: item.title,
          onClick: ($event: any) => (action(item.action))
        }, null, 8 /* PROPS */, ["type", "title", "onClick"]))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_authControlItems.value, (item) => {
        return (_openBlock(), _createBlock(MobileMenuListItem, {
          type: item.type,
          title: item.title,
          icon: item.icon,
          "messages-count": item.messagesCount,
          onClick: ($event: any) => (item.action && action(item.action))
        }, null, 8 /* PROPS */, ["type", "title", "icon", "messages-count", "onClick"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ])
  ]))
}
}

})